import { useEffect } from 'react';
import Chart from 'chart.js'
import { DS_CHART_TOKENS, getCanvasChartColor } from '../../../utils/chartTheme';

const SemiDonughnutGraph = ({ completed, id = 'myChart', total, title = '', liner = '', color = DS_CHART_TOKENS.semBlue400, classes = '', graphClasses = '', metricValue = '', linerStyles = 'bottom-11' }) => {
  const percentage = total > 0 ? Math.round(completed / total * 100) : 0;
  const bluePercent = percentage
  const grayPercent = percentage > 100 ? 0 : 100 - percentage

  useEffect(() => {
    drawGraph()
  }, [completed, total])

  const drawGraph = () => {
    var ctx = document.getElementById(id).getContext('2d')

    new Chart(ctx, {
      type: 'doughnut',
      data: {
        datasets: [
          {
            data: [bluePercent, grayPercent],
            backgroundColor: [getCanvasChartColor(color), getCanvasChartColor(DS_CHART_TOKENS.gray200)],
            borderColor: getCanvasChartColor(DS_CHART_TOKENS.paper),
            borderWidth: 2,
            hoverBorderColor: getCanvasChartColor(DS_CHART_TOKENS.paper),
          },
        ],
      },
      options: {
        rotation: 1 * Math.PI,
        circumference: 1 * Math.PI,
        tooltips: {
          enabled: false,
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
          },
        },
        responsive: true,
        legend: {
          display: false,
          position: 'top',
        },
        title: {
          display: false,
          text: title,
        },
        cutoutPercentage: 86,
        animation: {
          duration: 700,
          easing: 'easeOutQuart',
        },
      },
    });
  }

  return (
    <div className={`bg-white border border-gray-200 rounded-[14px] px-6 py-6 shadow-sm ${classes}`}>
      <div className={`flex flex-col items-center relative ${graphClasses}`}>
        <div className='text-3xl text-gray-900 font-semibold absolute font-jetbrains-mono tabular-nums tracking-tight' style={{ bottom: '3.9rem' }}>{percentage}%</div>
        <div style={{ fontSize: '11px' }} className={`text-gray-500 absolute font-medium ${linerStyles}`}>{liner}</div>
        <div className='myChartDiv relative'>
          <canvas id={id} width='200' height='200'></canvas>
          <div className='absolute bottom-6 w-52 flex justify-between text-[11px] text-gray-500 font-jetbrains-mono'>
            <span>0%</span>
            <span>100%</span>
          </div>
        </div>
      </div>
      {metricValue && <div className='text-center text-gray-500 text-sm font-medium mt-2'>{metricValue}</div>}
    </div>
  )
}

export default SemiDonughnutGraph
